/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeletedWorkspace
 */
export interface DeletedWorkspace {
    /**
     * 
     * @type {string}
     * @memberof DeletedWorkspace
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DeletedWorkspace
     */
    path: string;
}

export function DeletedWorkspaceFromJSON(json: any): DeletedWorkspace {
    return DeletedWorkspaceFromJSONTyped(json, false);
}

export function DeletedWorkspaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeletedWorkspace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'path': json['path'],
    };
}

export function DeletedWorkspaceToJSON(value?: DeletedWorkspace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'path': value.path,
    };
}


